var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-cmp"},[_c('div',{staticClass:"cc-header"},[_c('dv-decoration-1',{staticStyle:{"width":"200px","height":"50px"}}),_c('div',[_vm._v("全国物流")]),_c('dv-decoration-1',{staticStyle:{"width":"200px","height":"50px"}})],1),_c('div',{attrs:{"id":"map"}},[_vm._v("\n    main\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }